import { useState, useEffect } from "react";

import { useGetExperianAuthState } from "manager/hooks/api/experianAuthQueries";
import { isExperianProvider } from "manager/pages/ExperianAuth/utils";
import { useActiveCompany } from "shared/hooks";
import { usePermissions } from "shared/hooks";

const EXPERIAN_BYPASS_KEY = "experian_auth_bypassed";

export const useExperianBypassStatus = () => {
  const { canBypassExperianAuth } = usePermissions();
  const { activeCompany: company } = useActiveCompany();
  const { experianAuth } = useGetExperianAuthState(company);
  const userExperianAuthenticated = !!experianAuth?.experian?.userAuthenticated;

  // Check if user has bypassed auth in this session
  const [hasUserBypassed, setHasUserBypassed] = useState(false);

  useEffect(() => {
    const bypassed = sessionStorage.getItem(EXPERIAN_BYPASS_KEY) === "true";
    setHasUserBypassed(bypassed);
  }, [canBypassExperianAuth, company, userExperianAuthenticated]);

  const isExperianCompany = company && isExperianProvider(company);
  const hasBypassedAuth =
    canBypassExperianAuth &&
    isExperianCompany &&
    !userExperianAuthenticated &&
    hasUserBypassed;

  return {
    hasBypassedAuth,
    isExperianCompany,
    userExperianAuthenticated,
    canBypassExperianAuth,
  };
};

export const setExperianBypassed = () => {
  sessionStorage.setItem(EXPERIAN_BYPASS_KEY, "true");
};

export const clearExperianBypassed = () => {
  sessionStorage.removeItem(EXPERIAN_BYPASS_KEY);
};
